<app-header (clickEmitter)="toggleSidenavOpenState()" (contextmenu)="toggleOverlappedState($event)">
</app-header>

<mat-sidenav-container autosize class="main-container">
  <mat-sidenav [mode]="(isCompact | async) || (isSidenavOverlapped | async) ? 'over' : 'side'"
    [opened]="(isCompact | async) ? compactSidenavOpen : (isSidenavOpen | async)"
    (openedChange)="onSidenavOpenChange($event)"
    class="main-sidenav">
    <div class="native-scroll native-scroll--sidebar">
      <mat-nav-list role="list">
        @for (link of navLinks; track link) {
          @if (link.children && link.children.length > 0) {
            <mat-accordion>
              <mat-expansion-panel class="side-exp" routerLinkActive="active">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon style="margin-right: 10px">{{ link.icon }}</mat-icon>
                    <span>{{ link.label | translate }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @for (child of link.children; track child) {
                  <a [routerLink]="child.path" (click)="closeCompactSidenav()">
                    <mat-list-item class="child" role="listitem">
                      <mat-label style="margin-left: 10px">{{ child.label | translate }}</mat-label>
                    </mat-list-item>
                  </a>
                }
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (!link.children || link.children.length === 0) {
            <a [routerLink]="link.path" (click)="closeCompactSidenav()"
              routerLinkActive="active">
              <mat-list-item role="listitem">
                <span class="sidebar-link-content">
                  <mat-icon>{{ link.icon }}</mat-icon>
                  <mat-label style="margin-left: 10px">{{ link.label | translate }}</mat-label>
                </span>
              </mat-list-item>
            </a>
          }
        }
      </mat-nav-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
